export function toJSTDateString(dateInput: string | Date): string {
  const date = new Date(dateInput);
  date.setHours(date.getHours() + 9); // JST補正
  return date.toISOString().slice(0, 10);
}

// 日時を「YYYY/MM/DD HH:mm」（ブラウザのローカル時刻）で表示する。
// 鍵の貸出・返却時間のように「時刻」まで見せたい箇所で使う。
export function toJSTDateTimeString(dateInput: string | Date): string {
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "-";
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

// <input type="datetime-local"> に渡す値（YYYY-MM-DDTHH:mm）へ変換する。
export function toLocalInputValue(dateInput: string | Date): string {
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";
  const pad = (n: number) => n.toString().padStart(2, "0");
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
